import Carousel from 'react-bootstrap/Carousel';
import './slider.scss'

interface ISlider {
  interval?: number;
  imgDataArray: string[];
  fade?: boolean;
  slide?: boolean;
  indicators?: boolean;
  controls?: boolean;
}

const ImageSlider: React.FC<ISlider> = (props) => {
  const { interval = 3000, imgDataArray, fade = true, slide = false, indicators = true, controls = false } = props
  return (
    <Carousel className='slider-main-wrapper' fade={fade} slide={slide} indicators={indicators} controls={controls}>
      {imgDataArray?.map((imgSrc, index) => {
        return (
          <Carousel.Item interval={interval} key={index}>
          <img src={imgSrc} alt="slider-image"/>
        </Carousel.Item>
        )
      })}
    </Carousel>
  );
}

export default ImageSlider;